import { Box, Button, InputLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import moment from "moment";
import ReactModal from "../../../../Components/Modal/Modal";
import Input from "../../../../Components/Input/Input";
import { useStyle } from "../HRMSetup/Departments/department-styles";
import {
  formatAmountInputDisplay,
  parseAmountNumber,
  preventInvalidAmountKeys,
} from "../../../../Utils/helper";

const amountInputProps = {
  inputMode: "decimal",
  onKeyDown: preventInvalidAmountKeys,
};

const ApproveLoanModal = ({
  open,
  setOpen,
  onConfirm,
  loading = false,
  initialServiceCharge = 0,
}) => {
  const deptClasses = useStyle();
  const [issueDate, setIssueDate] = useState("");
  const [serviceCharge, setServiceCharge] = useState("");

  useEffect(() => {
    if (open) {
      setIssueDate(moment().format("YYYY-MM-DD"));
      setServiceCharge(
        formatAmountInputDisplay(String(initialServiceCharge ?? 0)),
      );
    }
  }, [open, initialServiceCharge]);

  const handleSubmit = () => {
    if (!issueDate) {
      return;
    }
    const parsedCharge = parseAmountNumber(serviceCharge) || 0;
    if (parsedCharge < 0) {
      return;
    }
    onConfirm({ issueDate, serviceCharge: parsedCharge });
  };

  return (
    <ReactModal open={open} setOpen={setOpen} title="Approve Loan Request">
      <Box sx={{ my: 2 }}>
        <Input>
          <Form.Label>Issue Date</Form.Label>
          <Form.Control
            type="date"
            value={issueDate}
            onChange={(e) => setIssueDate(e.target.value)}
          />
        </Input>
      </Box>
      <Box sx={{ my: 2 }}>
        <InputLabel className={deptClasses.department_label}>
          Service Charge (Rs)
        </InputLabel>
        <TextField
          fullWidth
          className={deptClasses.inputContainer}
          type="text"
          value={serviceCharge}
          inputProps={amountInputProps}
          onChange={(e) =>
            setServiceCharge(formatAmountInputDisplay(e.target.value))
          }
          sx={{ mt: 1 }}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Button
            variant="contained"
            className={deptClasses.cancelBtn}
            onClick={() => setOpen(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className={deptClasses.createBtn}
            onClick={handleSubmit}
            disabled={loading || !issueDate}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Approve"}
          </Button>
        </Box>
      </Box>
    </ReactModal>
  );
};

export default ApproveLoanModal;
